// extracted by mini-css-extract-plugin
export var box = "BurgerBtn-module--box--71e7f";
export var box_md = "BurgerBtn-module--box_md--3c8ab";
export var box_xmd = "BurgerBtn-module--box_xmd--f1f9c";
export var box_flex = "BurgerBtn-module--box_flex--f6309";
export var box_lg = "BurgerBtn-module--box_lg--e594f";
export var box_sm = "BurgerBtn-module--box_sm--355f3";
export var box_outer = "BurgerBtn-module--box_outer--67e8a";
export var box_whiteBg = "BurgerBtn-module--box_white-bg--163a2";
export var box_noMarginBottom = "BurgerBtn-module--box_no-margin-bottom--c19ef";
export var box_noPadding = "BurgerBtn-module--box_no-padding--9d4ab";
export var box_outerGray = "BurgerBtn-module--box_outer-gray--9ec15";
export var box_dark = "BurgerBtn-module--box_dark--f32d9";
export var box_zIndex = "BurgerBtn-module--box_z-index--d58dc";
export var box_zIndex6 = "BurgerBtn-module--box_z-index-6--0fd38";
export var box_eventsWithLine = "BurgerBtn-module--box_events-with-line--711fa";
export var box_featuresAo = "BurgerBtn-module--box_features-ao--3c625";
export var box_verticalPaddings = "BurgerBtn-module--box_vertical-paddings--30abd";
export var clearP = "BurgerBtn-module--clearP--4fe5c";
export var clearP_vc = "BurgerBtn-module--clearP_vc--ef65a";
export var wrapper = "BurgerBtn-module--wrapper--56701";
export var fixed = "BurgerBtn-module--fixed--a5bd3";
export var button = "BurgerBtn-module--button--0037d";
export var active = "BurgerBtn-module--active--a6c5c";
export var fadeInAnimation = "BurgerBtn-module--fadeInAnimation--bae50";
export var placeHolderShimmer = "BurgerBtn-module--placeHolderShimmer--db93b";